// map styles
export const SATELLITE_MAP_STYLE = {
  label: 'Satellite',
  value: 'satellite',
};
export const DARK_MAP_STYLE = {
  label: 'Dark',
  value: 'dark',
};
// Monochrome is deprecated in favor of dark but kept for backward compatibility
export const MONOCHROME_MAP_STYLE = {
  label: 'Monochrome',
  value: 'monochrome',
};
export const LIGHT_MAP_STYLE = {
  label: 'Light',
  value: 'light',
};
